"use client";

import Image from "next/image";

import TransferIcon from "../../assets/wallet/icon/transfer-to-account.png";
import type { WalletWithdrawalCTADTO } from "../../types/cms/profile-page";
import { Button } from "../ui/button";

interface WithdrawalCTAProps {
  hasAvailableWithdrawal: boolean;
  cms: WalletWithdrawalCTADTO;
  onRequestWithdrawal?: () => void;
}

export function WithdrawalCTA({
  hasAvailableWithdrawal,
  cms,
  onRequestWithdrawal,
}: Readonly<WithdrawalCTAProps>) {
  return (
    <div
      className="flex flex-col items-center gap-4 my-12 mx-4"
      data-testid="withdrawal-cta-wrapper"
    >
      <p className="text-md text-gray-600">{cms.description}</p>
      <Button
        type="button"
        variant="outline"
        disabled={!hasAvailableWithdrawal}
        aria-disabled={!hasAvailableWithdrawal}
        onClick={onRequestWithdrawal}
        className="flex items-center gap-2 rounded-full border-2 border-brand-blue px-6 py-3 text-sm font-semibold text-brand-blue hover:border-brand-cyan hover:text-brand-cyan transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-50"
        data-testid="withdrawal-cta-button"
      >
        <Image
          src={TransferIcon}
          alt=""
          width={16}
          height={16}
          className="[filter:brightness(0)_saturate(100%)_invert(16%)_sepia(26%)_saturate(1590%)_hue-rotate(185deg)_brightness(95%)_contrast(90%)]"
        />
        {cms.ctaLabel}
      </Button>
    </div>
  );
}
